module.exports = __webpack_public_path__ + "static/media/error.b5d92eb0.svg";